import { AvailityServiceReviewConfiguration } from "risa-data-model";
import { ApiBaseUrls } from "../../enums/apiUrls";
import { isProduction } from "../../utils/runtimeEnv";
import { getBearerToken } from "./bearerToken";

export const makePostCallWithFormConfig = async (
  id: string,
  setLoading: (loading: boolean) => void,
  availityConfigurationDocRef: AvailityServiceReviewConfiguration,
) => {
  try {
    handleLoadingState(setLoading, true);

    const payload = {
      orderId: id,
      availityServiceReviewConfiguration: availityConfigurationDocRef,
    };

    const token = await getBearerToken();
    if (!token) return;
    await makePostRequest(payload, token);
  } catch (error) {
    console.error("Background submission error:", error);
  } finally {
    handleLoadingState(setLoading, false);
  }
};

const makePostRequest = async (payload: any, token: string) => {
  const response = await fetch(
    isProduction()
      ? ApiBaseUrls.PROD_SUBMI_PA_FORM
      : ApiBaseUrls.DEV_SUBMI_PA_FORM,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    console.error("Background submission failed:", response.statusText);
  } else {
    console.log("Submission successful");
  }
};

const handleLoadingState = (
  setLoading: (loading: boolean) => void,
  isLoading: boolean,
) => {
  setLoading(isLoading);
};
